export default __webpack_public_path__ + "static/media/icon_design.0539c7e2.svg";